<div class="pcf-container">
  @if (!isUserExternalSupplier) {
    <mds-button-toggle
      [checkedButton]="selectedTab"
      [multiple]="false"
      [options]="tabs"
      (change)="onSwitchView($event)"
    ></mds-button-toggle>
  }
  @if (selectedTab === campaignTabs.QUESTIONNAIRES) {
    <ngx-masonry [ordered]="true">
      <section class="questionnaire-container">
        <header-compose [headerIcon]="icons.CO_2" [headerText]="title" headerTag="h3">
          <div>
            <p>
              In the questionnaire both the “company” and “company site” terms are used as some suppliers are only
              delivering data for a single entity and some suppliers have more submissions to attend to for multiple
              sites within their company.
            </p>
            <p>
              To answer the questionnaire and submit your scope 1&2 CO₂e data, We recommend using the standard from the
              GHG Protocol which sets standards to measure and manage emissions. This link provides access to the
              standard as well as tools and training material.
            </p>
            <p>Please answer all questions before submitting.</p>
          </div>
        </header-compose>

        @if (productInfo) {
          <section class="sections">
            <header-compose [headerIcon]="icons.INFO" [headerText]="productInfo?.name" headerTag="h4"></header-compose>

            <form [formGroup]="productInfoForm" class="form-container">
              <formly-form
                [fields]="productInfoFieldTypes"
                [model]="productInfoForm"
                [form]="productInfoForm"
              ></formly-form>
            </form>
          </section>
        }
        @if (isReporting && reporting) {
          <section class="sections">
            <header-compose [headerIcon]="icons.ECO" [headerText]="reporting?.name" headerTag="h4"></header-compose>

            <form [formGroup]="reportingForm" class="form-container">
              <formly-form [fields]="reportingFieldTypes" [model]="reportingForm" [form]="reportingForm"></formly-form>
            </form>
          </section>
        }
        @if (!isReporting && materialBreakdown) {
          <section class="material-section">
            <header-compose
              [headerIcon]="icons.BREAKDOWN"
              [headerText]="materialBreakdown?.name"
              headerTag="h4"
            ></header-compose>

            <div>
              <div class="materials">
                <h5>Materials</h5>
                <div class="grid-actions">
                  @if (materialBreakdown.materials?.actions?.edit) {
                    <mds-button
                      type="tertiary"
                      [disabled]="!materialBreakdown.materials.actions?.edit || isBomImportInprogress"
                      (click)="fileInput.click()"
                    >
                      <input #fileInput type="file" (change)="importBom($event)" style="display: none" />
                      <mds-icon [key]="icons.DOWNLOAD" [pathColors]="['#383838']" [width]="20" [height]="20"></mds-icon>
                      Import BOM
                    </mds-button>
                  }
                  @if (materialBreakdown?.materials?.actions?.new) {
                    <mds-button
                      type="tertiary"
                      [disabled]="!materialBreakdown?.materials.actions?.new"
                      (click)="addRow(true)"
                    >
                      <mds-icon [key]="icons.PLUS" [pathColors]="['#383838']" [width]="20" [height]="20"></mds-icon>
                      Add new material
                    </mds-button>
                  }
                  @if (materialBreakdown?.materials?.actions?.delete) {
                    <mds-button
                      type="tertiary"
                      [disabled]="
                        !materialBreakdown?.materials.actions?.edit || !materialsGridApi?.getSelectedRows()?.length
                      "
                      (click)="removeSelected(true)"
                    >
                      <mds-icon [key]="icons.TRASH" [pathColors]="['#383838']" [width]="20" [height]="20"></mds-icon>
                      Delete selected materials
                    </mds-button>
                  }
                </div>
              </div>

              <mds-grid
                [themeClass]="'ag-theme-material'"
                style="width: 100%; height: 400px"
                [overrides]="materialsGridOverrides"
                [sizeColumnsToFit]="false"
                (gridReady)="getMaterialsGridApi($event)"
              ></mds-grid>
            </div>

            <div>
              <div class="processes">
                <h5>Processes</h5>
                <div class="grid-actions">
                  @if (materialBreakdown?.processes?.actions?.edit) {
                    <mds-button
                      type="tertiary"
                      [disabled]="!materialBreakdown?.processes.actions?.edit"
                      (click)="addRow(false)"
                    >
                      <mds-icon [key]="icons.PLUS" [pathColors]="['#383838']" [width]="20" [height]="20"></mds-icon>
                      Add new process
                    </mds-button>
                  }
                  @if (materialBreakdown?.processes?.actions?.delete) {
                    <mds-button
                      type="tertiary"
                      [disabled]="
                        !materialBreakdown?.processes.actions?.edit || !processesGridApi?.getSelectedRows()?.length
                      "
                      (click)="removeSelected(false)"
                    >
                      <mds-icon [key]="icons.TRASH" [pathColors]="['#383838']" [width]="20" [height]="20"></mds-icon>
                      Delete selected processes
                    </mds-button>
                  }
                </div>
              </div>

              <mds-grid
                [themeClass]="'ag-theme-material'"
                style="width: 100%; height: 400px"
                [overrides]="processesGridOverrides"
                [sizeColumnsToFit]="false"
                (gridReady)="getProcessesGridApi($event)"
              ></mds-grid>
            </div>

            <div class="material-footer-container">
              <mds-button [isIconLeft]="true" [icon]="icons.RECALCULATE" (click)="recalculateImpact()">
                Recalculate
              </mds-button>
            </div>
          </section>
        }
        @if (productFootprintResults) {
          <section class="sections">
            <header-compose [headerIcon]="icons.EQUAL" [headerText]="productFootprintResults?.title" headerTag="h3">
              <div>
                <p>Final results comparing the current and calculated carbon footprints, including any reduction.</p>
              </div>
            </header-compose>

            <div class="result-section">
              @for (res of resultSection; track res) {
                <mds-numbers-widget
                  [headerTop]="res.value.headerTop"
                  [isNumbers]="true"
                  [headerBottom]="res.value.headerBottom"
                  [list]="res.value.list"
                  [totalItem]="res.value.totalItem"
                  [headerIconColors]="res.value.headerTop.iconColor"
                  [headerBackgroundColor]="getCardColor(res.value.headerBottom?.data)"
                ></mds-numbers-widget>
              }
            </div>
          </section>
        }
      </section>
    </ngx-masonry>

    @if (productInfo.actions?.edit) {
      <app-actions-panel class="save-floating-btn" [mode]="'floating'" [data]="saveAction"></app-actions-panel>
    }
  }
  @if (selectedTab === campaignTabs.HISTORY) {
    <app-request-history class="campaign__history" [rid]="rid"></app-request-history>
  }
</div>
